import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Invoices } from 'components/Invoices';

export const InvoicesPage: FC = () => {
	return (
		<Page title="Invoices Page – EAS Dashboard">
			<Invoices />
		</Page>
	);
};
